<template>
  <div class="contact">
    <div class="firstLine title">请留下您的联系方式，</div>
    <div class="secondLine title">我们将第一时间与您沟通</div>
    <a-form :form="form" class="form" @submit="handleSubmit">
      <a-form-item>
        <a-input
          v-decorator="['name', { rules: [{ required: true, message: '请输入您的姓名' }] }]"
          placeholder="请输入您的姓名"
        />
      </a-form-item>
      <a-form-item>
        <a-input
          v-decorator="['phone', { rules: [{ required: true, message: '请输入您的手机号' }, { validator: checktelphone }] }]"
          placeholder="请输入您的手机号"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">
          信息提交
        </a-button>
      </a-form-item>
    </a-form>
    <div id="captcha" />
    <img class="img_code" src="@/assets/Mobile/images/home/submit_code.png" />
    <p class="code_text">扫码咨询</p>
  </div>
</template>

<script>
import { simpleInformationCollection } from '@/apis/index'

export default {
  name: 'ContactForm',
  props: {
    title: {
      type: String,
      default: '咨询服务 立即预约'
    },
    infoSources: {
      type: String,
      default: '汇通数科官网-首页'
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      captchaIns: null,
      params: null
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.captchaIns.popUp()
          this.params = {
            infoSources: '汇通数科官网-' + this.infoSources,
            officialWebsiteEntrance: '公众号',
            name: values.name,
            phone: values.phone
          }
        }
      })
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          // that.captchaIns.close()
          that.params.pictureCode = data.validate
          simpleInformationCollection(that.params).then(res => {
            that.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            that.captchaIns.refresh()
            that.form.resetFields()
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
.img_code{
    width: 154px;
    height: 154px;
}
.code_text{
    height: 22px;
font-size: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 22px;
margin-top: 20px;
}
 .contact {
  height: 538px;
  background: url("~@/assets/Mobile/images/home/home_contact-bg.png") no-repeat center;
  background-size: 100%;
  padding: 0 16px;
  .firstLine {
    padding: 40px 0 17px;
  }
  .secondLine {
    padding-bottom: 40px;
  }
  .title {
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
    text-align: center;
  }

  .form {
    // width: 375px;
    // margin: 0 auto;
  }
  /deep/ .ant-input {
    height: 44px;
    font-size: 16px;
    font-weight: 400;
  }
  /deep/ .ant-btn {
    width: 343px;
    height: 44px;
    background: #3986FF;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
  }
}
</style>
